import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  // a light band on the table card's top edge; it keeps its size whatever is selected, so the table doesn't move
  toolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
    minHeight: theme.spacing(14),
    padding: theme.spacing(2, 3),
    backgroundColor: theme.colorPalette.beige_25,
    textAlign: 'left'
  },
  selection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginRight: theme.spacing(2),
    color: theme.colorPalette.green_100,
    fontSize: 14
  },
  // the theme's disabled button (white !important, at 40%) is meant for dark fills and vanishes on the beige band
  action: {
    '&&.Mui-disabled': {
      color: `${theme.colorPalette.green_75_op_60} !important`,
      borderColor: theme.colorPalette.green_75_op_40,
      opacity: 1
    }
  },
  remove: {
    marginLeft: 'auto',
    color: theme.colors.error
  }
}));
